import React from "react";
import { Sparkles, Lock } from "lucide-react";
import { useWsNavigate } from "../../hooks/useWsNavigate";

// Presentational "this feature needs Growth" panel. Rendered by FeatureRoute
// (see App.js) in place of a page whose plan-gated feature is disabled for a
// pay-as-you-go workspace — a monetization opportunity, not an error state.
const GROWTH_BENEFITS = ["12,000 credits/month", "Co-Pilot", "scheduled runs", "alert monitors"];

function formatList(items) {
  if (items.length === 0) return "more";
  if (items.length === 1) return items[0];
  return `${items.slice(0, -1).join(", ")} and ${items[items.length - 1]}`;
}

export default function UpgradeGate({ featureLabel }) {
  const navigate = useWsNavigate();
  const label = featureLabel || "This";
  // The heading already names the gated feature — don't restate it in the
  // benefit list below (e.g. gating Co-Pilot shouldn't read "... Co-Pilot is
  // a Growth feature. Upgrade to Growth for ... Co-Pilot ...").
  const benefits = GROWTH_BENEFITS.filter((b) => b.toLowerCase() !== label.toLowerCase());

  return (
    <div className="mx-auto max-w-lg text-center rounded-2xl border border-border bg-card p-10 mt-10">
      <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Lock className="h-5 w-5" />
      </div>
      <h2 className="text-lg font-semibold text-foreground">{label} is a Growth feature</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Upgrade to Growth for {formatList(benefits)}, and more.
      </p>
      <button
        onClick={() => navigate("/settings/billing?upgrade=1")}
        className="mt-5 inline-flex items-center gap-2 rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90"
      >
        <Sparkles className="h-4 w-4" /> Upgrade to Growth
      </button>
    </div>
  );
}
